"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const Icon_1 = __importDefault(require("../Icon/Icon"));
require("./FieldLabel.scss");
const FieldLabel = (0, react_1.forwardRef)(({ icon = "", iconLabel = "", labelText = "", labelFor = "", iconClassName = "", labelClassName = "" }, ref) => {
    if (!labelText) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)("section", Object.assign({ className: "label-component--wrapper" }, { children: [(0, jsx_runtime_1.jsx)(Icon_1.default, { icon: icon, className: (0, classnames_1.default)("label-component--icon", iconClassName), id: labelFor, clickable: false, iconLabel: iconLabel, iconType: Icon_1.default.type.ICON_FONT }), (0, jsx_runtime_1.jsx)("label", Object.assign({ htmlFor: labelFor, ref: ref, className: (0, classnames_1.default)("label-component--text", labelClassName) }, { children: labelText }))] })));
});
exports.default = FieldLabel;
